import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../../core/services/config.service';
import { RequestService } from '../../../core/services/request.service';

import { ConfigurationDetails } from './details/configuration-details.model';

@Injectable()
export class ConfigurationService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {}

    delete(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.configuration.delete.api;
        return this.requestService.post(url, details);
    }

    getConfigurationDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.configuration.details.api + '/' + id;
        return this.requestService.get(url);
    }
    getConfigurationFields(): Array<any> {
        let fields = [
            {
                key: 'configKey',
                label: 'Key',
                type: 'text'
            },
            {
                key: 'configValue',
                label: 'Value',
                type: 'text'
            },
            {
                key: 'configType',
                label: 'Type',
                type: 'text'
            },
            {
                key: 'systemConfig',
                label: 'System',
                type: 'boolean'
            }
        ];
        return fields;
    }

    getAddFields(): Array<any> {
        let fields = [
            {
                key: 'configKey',
                label: 'Key',
                type: 'textbox',
                required: true
            }, {
                key: 'configValue',
                label: 'Value',
                type: 'textbox',
                required: true
            }, {
                key: 'configType',
                label: 'Type',
                type: 'dropdown',
                required: true,
                dictionaryUrl: this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.configurationType.api
            }, {
                key: 'systemConfig',
                label: 'System',
                type: 'radio',
                required: true,
                options: [
                    {key: true,  value: 'Yes'},
                    {key: false,  value: 'No'}
                ],
                default: false
            }
        ];

        return fields;
    }

    getEditFields(): Array<any> {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden'
            }, {
                key: 'configKey',
                label: 'Key',
                type: 'text'
            }, {
                key: 'configValue',
                label: 'Value',
                type: 'textbox',
                required: true
            }, {
                key: 'configType',
                label: 'Type',
                type: 'text'
            }, {
                key: 'systemConfig',
                label: 'System',
                type: 'radio',
                required: true,
                options: [
                    {key: true,  value: 'Yes'},
                    {key: false,  value: 'No'}
                ],
                default: false
            }
        ];

        return fields;
    }
}


// WEBPACK FOOTER //
// ./src/app/agora/components/configurations/configuration.service.ts